import type { LegacyQuoteCard, OpinionLayer, Trail } from '@/types';

export const mockQuoteCards: LegacyQuoteCard[] = [
  {
    id: '1',
    quote: '…the minimum wage shall be $7.25 per hour, effective July 24, 2009…',
    source: 'U.S. Department of Labor',
    documentTitle: 'Fair Labor Standards Act (as amended)',
    date: '2009-07-24',
    canonicalLink: 'https://www.dol.gov/agencies/whd/flsa',
    lane: 'A',
    laneLabel: 'Lane A — Primary text',
    context:
      'Section 206. Minimum wage. (a) Except as otherwise provided in this section, every employer shall pay to each of his employees who in any workweek is engaged in commerce or in the production of goods for commerce, or is employed in an enterprise engaged in commerce or in the production of goods for commerce, wages at the following rates: (1) except as otherwise provided in this section, not less than— (A) $5.85 an hour, beginning on the 60th day after the date of enactment of the Fair Minimum Wage Act of 2007; (B) $6.55 an hour, beginning 12 months after that 60th day; and (C) $7.25 an hour, beginning 24 months after that 60th day.',
    effectiveDate: '2009-07-24',
    amendedBy: 'Fair Minimum Wage Act of 2007',
    supersededBy: 'None',
  },
  {
    id: '2',
    quote:
      '…the purpose of the minimum wage is to protect the lowest-paid workers from unduly low pay due to their weak bargaining position…',
    source: 'Congressional Record',
    documentTitle: 'Senate Debate on Fair Labor Standards Amendments',
    date: '1966-09-14',
    canonicalLink: 'https://www.congress.gov/congressional-record',
    lane: 'B',
    laneLabel: 'Lane B — Contemporaneous record',
    context:
      'The minimum wage provisions were designed to establish a floor under wages in industries affecting commerce, thereby eliminating conditions detrimental to the maintenance of the minimum standard of living necessary for health, efficiency, and general well-being of workers.',
  },
  {
    id: '3',
    quote: '…in 2023, 1.6 million workers earned wages at or below the federal minimum wage…',
    source: 'Bureau of Labor Statistics',
    documentTitle: 'Labor Force Characteristics by Minimum Wage Status',
    date: '2024-03-01',
    canonicalLink: 'https://www.bls.gov/cps/minwage2023.htm',
    lane: 'C',
    laneLabel: 'Lane C — Modern data',
    context:
      'This report presents data on workers earning at or below the federal minimum wage. The data are obtained from the Current Population Survey (CPS), a national monthly survey of approximately 60,000 households conducted by the U.S. Census Bureau for the U.S. Bureau of Labor Statistics.',
  },
  {
    id: '4',
    quote:
      '…the Bureau of Labor Statistics reports that minimum wage workers tend to be young, with 46.6% under age 25…',
    source: 'Bureau of Labor Statistics',
    documentTitle: 'Characteristics of Minimum Wage Workers, 2023',
    date: '2024-03-01',
    canonicalLink: 'https://www.bls.gov/opub/reports/minimum-wage/2023/home.htm',
    lane: 'C',
    laneLabel: 'Lane C — Modern data',
    context:
      'Minimum wage workers tend to be young. Although workers under age 25 represented only about one-fifth of hourly paid workers, they made up 46.6% of those who earned the federal minimum wage or less.',
  },
  {
    id: '5',
    quote:
      '…Congress finds that the existence of unfair wage differentials based on sex… depresses wages and living standards…',
    source: 'U.S. Congress',
    documentTitle: 'Equal Pay Act of 1963',
    date: '1963-06-10',
    canonicalLink: 'https://www.eeoc.gov/statutes/equal-pay-act-1963',
    lane: 'A',
    laneLabel: 'Lane A — Primary text',
    context:
      'The Congress hereby finds that the existence in industries engaged in commerce or in the production of goods for commerce of wage differentials based on sex— (1) depresses wages and living standards for employees necessary for their health and efficiency; (2) prevents the maximum utilization of the available labor resources; (3) tends to cause labor disputes, thereby burdening, affecting, and obstructing commerce; (4) burdens commerce and the free flow of goods in commerce; and (5) constitutes an unfair method of competition.',
    effectiveDate: '1963-06-11',
  },
  {
    id: '6',
    quote: '…the federal minimum wage has lost 30% of its purchasing power since 2009…',
    source: 'Economic Policy Institute',
    documentTitle: 'The Value of the Federal Minimum Wage',
    date: '2024-01-12',
    canonicalLink: 'https://www.epi.org/blog/minimum-wage-purchasing-power/',
    lane: 'C',
    laneLabel: 'Lane C — Modern analysis',
    context:
      'After adjusting for inflation, the federal minimum wage is worth 30% less today than it was at its peak in 1968. If it had kept pace with productivity growth since then, it would be over $23 per hour today.',
  },
];

export const mockOpinionLayer: OpinionLayer = {
  verdict: 'mixed',
  confidence: 'medium',
  reasons: [
    {
      id: 'r1',
      text: 'Supports employment stability',
      supportingCards: ['1', '3'],
    },
    {
      id: 'r2',
      text: 'Regional cost mismatch',
      supportingCards: ['3', '4'],
    },
    {
      id: 'r3',
      text: 'Small business strain cited',
      supportingCards: ['6'],
    },
  ],
  counterEvidence: ['2', '5'],
};

export const mockTrails: Trail[] = [
  {
    id: 't1',
    name: 'Minimum Wage History',
    cards: [mockQuoteCards[0], mockQuoteCards[1], mockQuoteCards[2]],
    notes: 'Key sources for the minimum wage video script',
    createdAt: new Date('2024-01-15'),
  },
  {
    id: 't2',
    name: 'Equal Pay Debate',
    cards: [mockQuoteCards[4]],
    notes: 'For the Twitter thread on pay equity',
    createdAt: new Date('2024-02-01'),
  },
];

export const searchResults: Record<string, LegacyQuoteCard[]> = {
  'minimum wage': [mockQuoteCards[0], mockQuoteCards[1], mockQuoteCards[2]],
  'minimum wage history': [mockQuoteCards[0], mockQuoteCards[1], mockQuoteCards[5]],
  'equal pay': [mockQuoteCards[4]],
  'bls data': [mockQuoteCards[2], mockQuoteCards[3]],
  workers: [mockQuoteCards[2], mockQuoteCards[3], mockQuoteCards[4]],
};
